export const getRouteParam = <P>(p: Record<string, unknown>): Partial<P> => {
  return { ...p } as Partial<P>
}
